import { Link, useLocation } from "react-router-dom";

export default function AdminNav() {
  const { pathname } = useLocation();

  const items = [
    { label: "Dashboard", to: "/admin", match: "/admin" },
    { label: "Leads", to: "/admin/leads", match: "/admin/leads" },
    { label: "Reports", to: "/admin/reports", match: "/admin/reports" },
    { label: "Estimates", to: "/admin/estimates", match: "/admin/estimates" },
    { label: "Invoices", to: "/admin/invoices", match: "/admin/invoices" },
    { label: "Expenses", to: "/admin/expenses", match: "/admin/expenses" },
  ];

  const isActive = (item) => {
    if (item.to === "/admin") {
      return pathname === "/admin";
    }
    return pathname.startsWith(item.match);
  };

  return (
    <nav className="admin-nav">
      <div className="admin-nav-title">Admin</div>
      <div className="admin-nav-links">
        {items.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={isActive(item) ? "admin-nav-link active" : "admin-nav-link"}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
